import {z} from 'zod';

/**
 * POST
 */
export const PostAlternativeSparePartsByCatalogueNumberRequestSchema = z.object({
  body: z.array(
    z.object({
      catalogueNumber: z.string(),
      manufacturerId: z.string(),
    })
  ),
});
export type PostAlternativeSparePartsByCatalogueNumberRequest = z.infer<
  typeof PostAlternativeSparePartsByCatalogueNumberRequestSchema
>;

const AlternativeSparePartReferenceSchema = z
  .object({
    id: z.string(),
    name: z.string(),
  })
  .nullable();

const AlternativeSparePartPriceSchema = z
  .object({
    amount: z.number().nullable(),
    currency: z.string().nullable(),
  })
  .nullable();

const AlternativeSparePartQuantitySchema = z
  .object({
    amount: z.number(),
    unit: z.string(),
  })
  .nullable();

export const AlternativeSparePartArticleSchema = z.object({
  warehouseArticleId: z.string(),
  name: z.string(),
  manufacturer: AlternativeSparePartReferenceSchema,
  warehouse: AlternativeSparePartReferenceSchema,
  purchasePrice: AlternativeSparePartPriceSchema.optional(),
  sellingPrice: AlternativeSparePartPriceSchema.optional(),
  margin: AlternativeSparePartPriceSchema.optional(),
  availableQuantity: AlternativeSparePartQuantitySchema.optional(),
  inTransitForRequest: AlternativeSparePartQuantitySchema.optional(),
  inTransitFree: AlternativeSparePartQuantitySchema.optional(),
  measurementUnit: z.string().nullish(),
  dispensingUnit: z.number().nullish(),
  defaultSupplier: z
    .object({
      id: z.string().nullable(),
      name: z.string().nullable(),
    })
    .nullish(),
});
export type AlternativeSparePartArticle = z.infer<typeof AlternativeSparePartArticleSchema>;

export const AlternativeSparePartGroupSchema = z.object({
  catalogueNumber: z.string(),
  articles: z.array(AlternativeSparePartArticleSchema.nullable()).nullish(),
});
export type AlternativeSparePartGroup = z.infer<typeof AlternativeSparePartGroupSchema>;

export const PostAlternativeSparePartsByCatalogueNumberResponseSchema = z
  .array(AlternativeSparePartGroupSchema)
  .nullable();
export type PostAlternativeSparePartsByCatalogueNumberResponse = z.infer<
  typeof PostAlternativeSparePartsByCatalogueNumberResponseSchema
>;
